import type { TFunction } from "i18next";
import moment from "moment";
import { ContractNature, type CpvCodeDto, ProcedureType } from "../../../../autogen/bff-api";
import { displayDate, type SupportedLocale } from "../../../../common/formatting/displayDate";

export const getBuyerInitials = (buyerName: string) =>
  buyerName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");

export const getDaysLeftMeta = (deadline: string, t: TFunction) => {
  const hoursLeft = moment(deadline).diff(moment(), "hours");

  if (hoursLeft <= 0) {
    return { label: t("Deadline passed"), color: "smMuted", iconColor: "smMuted" };
  }

  if (hoursLeft <= 24) {
    return { label: t("Less than 1 day left"), color: "smError", iconColor: "smError" };
  }

  const daysLeft = Math.ceil(hoursLeft / 24);
  return {
    label: `${daysLeft} ${t("days_left", { count: daysLeft })}`,
    color: daysLeft <= 3 ? "smError" : "smMuted",
    iconColor: daysLeft <= 3 ? "smError" : "smMuted",
  };
};

export const formatCpv = (cpv: CpvCodeDto, language: string) =>
  `${cpv.code} - ${language.startsWith("no") ? cpv.nameNb : cpv.nameEn}`;

export const getProcedureLabel = (procedureType: ProcedureType, t: TFunction) => t(procedureType);

export const getContractNatureLabel = (contractNature: ContractNature, t: TFunction) => {
  switch (contractNature) {
    case ContractNature.Supplies:
      return t("Goods");
    case ContractNature.Services:
      return t("Services");
    case ContractNature.Works:
      return t("Construction");
    case ContractNature.Combined:
      return t("Combined");
  }
};

export const formatEstimatedValue = (value: number, currency: string) =>
  `${value.toLocaleString("nb-NO")} ${currency}`;

export const formatShortDate = (value: string, locale?: SupportedLocale | null) =>
  displayDate(value, locale);
